import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IBrand) {
    (function(State) {
        /**
     * The brand was newly created.
     */ State["NEW"] = "NEW";
        State["WAITLISTED"] = "WAITLISTED";
        /**
     * THe onboarding form was sent to the brand.
     */ State["ONBOARDING_FORM_SENT"] = "ONBOARDING_FORM_SENT";
        /**
     * The brand has started the onboarding form.
     */ State["ONBOARDING_FORM_STARTED"] = "ONBOARDING_FORM_STARTED";
        /**
     * The brand has completed the onboarding form and we have their catalog.
     */ State["ONBOARDING_FORM_COMPLETED"] = "ONBOARDING_FORM_COMPLETED";
        /**
     * The brand has had at least one product uploaded.
     */ State["PROFILE_STARTED"] = "PROFILE_STARTED";
        /**
     * The brand has all of their products uploaded.
     */ State["ALL_PRODUCTS_UPLOADED"] = "ALL_PRODUCTS_UPLOADED";
        State["PROFILE_IN_DESIGN_REVIEW"] = "PROFILE_IN_DESIGN_REVIEW";
        State["PROFILE_IN_FINAL_REVIEW"] = "PROFILE_IN_FINAL_REVIEW";
        State["PROFILE_ACTIVATED"] = "PROFILE_ACTIVATED";
        /**
     * The brand was rejected from Faire.
     * @deprecated
     */ State["REJECTED"] = "REJECTED";
        State["PRE_ACTIVATION_REVIEW"] = "PRE_ACTIVATION_REVIEW";
        /**
     * Brand is uploading products in self serve
     */ State["SELF_SERVE_PRODUCT_UPLOAD"] = "SELF_SERVE_PRODUCT_UPLOAD";
        /**
     * Brand has requested assistance in upload products while in self serve
     */ State["ASSISTED_UPLOAD_PENDING"] = "ASSISTED_UPLOAD_PENDING";
        /**
     * Product catalog is being built by Faire in self serve
     */ State["ASSISTED_UPLOAD_STARTED"] = "ASSISTED_UPLOAD_STARTED";
        /**
     * Brand is reviewing their store in self serve
     */ State["SELF_SERVE_REVIEW"] = "SELF_SERVE_REVIEW";
        /**
     * Brand is reviewing their store after requesting self-serve assistance
     */ State["ASSISTED_SELF_SERVE_REVIEW"] = "ASSISTED_SELF_SERVE_REVIEW";
        /**
     * Brand is being reviewed for fraud by Faire
     */ State["FRAUD_REVIEW"] = "FRAUD_REVIEW";
        /**
     * Brand has been rejected for fraud
     */ State["REJECTED_FOR_FRAUD"] = "REJECTED_FOR_FRAUD";
    })(IBrand.State || (IBrand.State = {}));
    (function(ReferralRewardsState) {
        ReferralRewardsState["REFERRAL_REWARDS_STATE_UNKNOWN"] = "REFERRAL_REWARDS_STATE_UNKNOWN";
        ReferralRewardsState["REWARDS_NOT_APPLICABLE"] = "REWARDS_NOT_APPLICABLE";
        ReferralRewardsState["REWARDS_PENDING_APPROVAL"] = "REWARDS_PENDING_APPROVAL";
        ReferralRewardsState["REWARDS_APPROVED"] = "REWARDS_APPROVED";
        ReferralRewardsState["REWARDS_REJECTED"] = "REWARDS_REJECTED";
    })(IBrand.ReferralRewardsState || (IBrand.ReferralRewardsState = {}));
    (function(FederalTaxClass) {
        FederalTaxClass["C_CORPORATION"] = "C_CORPORATION";
        FederalTaxClass["S_CORPORATION"] = "S_CORPORATION";
        FederalTaxClass["INDIVIDUAL_OR_SOLE_PROPRIETOR"] = "INDIVIDUAL_OR_SOLE_PROPRIETOR";
        FederalTaxClass["LIMITED_LIABILITY_COMPANY"] = "LIMITED_LIABILITY_COMPANY";
        FederalTaxClass["OTHER"] = "OTHER";
    })(IBrand.FederalTaxClass || (IBrand.FederalTaxClass = {}));
    (function(BrandLeadType) {
        BrandLeadType["INBOUND"] = "INBOUND";
        BrandLeadType["OUTBOUND"] = "OUTBOUND";
        BrandLeadType["UNKNOWN"] = "UNKNOWN";
    })(IBrand.BrandLeadType || (IBrand.BrandLeadType = {}));
    (function(PurchaseOrderBrandType) {
        PurchaseOrderBrandType["NOT_A_PURCHASE_ORDER_BRAND"] = "NOT_A_PURCHASE_ORDER_BRAND";
        PurchaseOrderBrandType["WITH_UNCONFIRMED_USER"] = "WITH_UNCONFIRMED_USER";
        PurchaseOrderBrandType["WITH_CONFIRMED_USER"] = "WITH_CONFIRMED_USER";
        PurchaseOrderBrandType["WITH_EXISTING_USER"] = "WITH_EXISTING_USER";
    })(IBrand.PurchaseOrderBrandType || (IBrand.PurchaseOrderBrandType = {}));
    (function(IMinimum) {
        IMinimum.build = function(partial) {
            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IBrand.IMinimum || (IBrand.IMinimum = {}));
    (function(PrimaryCategory) {
        /**
     * @deprecated
     */ PrimaryCategory["APPAREL"] = "APPAREL";
        /**
     * @deprecated
     */ PrimaryCategory["FOOTWEAR"] = "FOOTWEAR";
        /**
     * @deprecated
     */ PrimaryCategory["ACCESSORIES"] = "ACCESSORIES";
        PrimaryCategory["OTHER_CATEGORY"] = "OTHER_CATEGORY";
        /**
     * @deprecated
     */ PrimaryCategory["KIDS_BABY"] = "KIDS_BABY";
        PrimaryCategory["HOME_DECOR"] = "HOME_DECOR";
        PrimaryCategory["FOOD_DRINK"] = "FOOD_DRINK";
        PrimaryCategory["BEAUTY_WELLNESS"] = "BEAUTY_WELLNESS";
        PrimaryCategory["PAPER_NOVELTY"] = "PAPER_NOVELTY";
        PrimaryCategory["PETS"] = "PETS";
        PrimaryCategory["JEWELRY"] = "JEWELRY";
        PrimaryCategory["WOMENS_APPAREL"] = "WOMENS_APPAREL";
        PrimaryCategory["WOMENS_ACCESSORIES"] = "WOMENS_ACCESSORIES";
        PrimaryCategory["MENS_APPAREL"] = "MENS_APPAREL";
        PrimaryCategory["MENS_ACCESSORIES"] = "MENS_ACCESSORIES";
        PrimaryCategory["KIDS_BABY_APPAREL"] = "KIDS_BABY_APPAREL";
        PrimaryCategory["KIDS_BABY_NON_APPAREL"] = "KIDS_BABY_NON_APPAREL";
        PrimaryCategory["RAW_MATERIALS"] = "RAW_MATERIALS";
        PrimaryCategory["CBD_THC"] = "CBD_THC";
    })(IBrand.PrimaryCategory || (IBrand.PrimaryCategory = {}));
    (function(CertificationType) {
        CertificationType["B_CORP"] = "B_CORP";
        CertificationType["GOTS"] = "GOTS";
        CertificationType["USDA_ORGANIC"] = "USDA_ORGANIC";
    })(IBrand.CertificationType || (IBrand.CertificationType = {}));
    (function(SizeSegment) {
        SizeSegment["SIZE_SEGMENT_UNKNOWN"] = "SIZE_SEGMENT_UNKNOWN";
        SizeSegment["SIZE_SEGMENT_1"] = "SIZE_SEGMENT_1";
        SizeSegment["SIZE_SEGMENT_2"] = "SIZE_SEGMENT_2";
        SizeSegment["SIZE_SEGMENT_3"] = "SIZE_SEGMENT_3";
        SizeSegment["SIZE_SEGMENT_4"] = "SIZE_SEGMENT_4";
    })(IBrand.SizeSegment || (IBrand.SizeSegment = {}));
    (function(OrderAutoAcceptConfiguration) {
        OrderAutoAcceptConfiguration["ORDER_AUTO_ACCEPT_CONFIGURATION_UNKNOWN"] = "ORDER_AUTO_ACCEPT_CONFIGURATION_UNKNOWN";
        /**
     * [Default] The brand will not automatically accept any new orders.
     */ OrderAutoAcceptConfiguration["DISABLED"] = "DISABLED";
        /**
     * The brand will automatically accept new orders from reordering retailers.
     */ OrderAutoAcceptConfiguration["ENABLED_REORDERS"] = "ENABLED_REORDERS";
        /**
     * The brand will automatically accept all new orders.
     */ OrderAutoAcceptConfiguration["ENABLED_ALL"] = "ENABLED_ALL";
    })(IBrand.OrderAutoAcceptConfiguration || (IBrand.OrderAutoAcceptConfiguration = {}));
    IBrand.build = function(partial) {
        return _object_spread({
            categories: [],
            deranked_categories: [],
            images: [],
            social_media_images: [],
            badges: [],
            squared_category_images: {},
            available_terms: [],
            restricted_states: [],
            forbidden_states: [],
            reduced_commission_states: [],
            restricted_countries: [],
            restricted_geo_constraints: [],
            memberships: [],
            story_images: [],
            active_brand_promos: [],
            active_promo_collections: [],
            order_minimum_overrides: [],
            minimums: [],
            certifications: [],
            business_identifiers: [],
            tags: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IBrand || (IBrand = {}));
export var IBrand;
